import Vue from 'vue'
import vuetify from './plugins/vuetify';
import Widget from './Widget'

import './filters'
import './directives'


Vue.config.productionTip = false

import sgbService from './api'

import routerWidget from './router/index.js'
import store from './store'


console.info('sg widget init, version:', process.env.VUE_WIDGET_VERSION)


const eventBus = new Vue()
Object.defineProperty(Vue.prototype, '$eventBus', {
  get() {
    return eventBus
  }
})

Object.defineProperty(Vue.prototype, '$api', {
  get() {
    return sgbService
  }
})

Vue.mixin({
  computed: {
    WIDGET_VERSION() {
      return process.env.VUE_WIDGET_VERSION
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
  methods: {


    postMessage(eventName, data) {

      console.log('postmessage')

      data = Object.assign({}, data, {
        eventName,
        uuid: this.$store.state.uuid
      })
      window.parent.postMessage(data, '*')
    }
  }
})

new Vue({
  vuetify,
  router: routerWidget,
  store,
  render: h => h(Widget),
}).$mount('#app');